import { Button, InputAdornment } from "@mui/material";
import React, { useEffect } from "react";
import Switch from "../../framework/Switch";
import TextInput from "../../framework/TextInput";
import classes from "./SearchHeader.module.css";
const SearchHeader = ({
  onSearchChange,
  onOnlineOnlyChange,
  onRefresh = () => {},
}) => {
  useEffect(() => {
    const interval = setInterval(() => {
      onRefresh();
    }, 30000);
    return () => clearInterval(interval);
  }, [onRefresh]);

  return (
    <div className={classes["searchContainer"]}>
      <div className={classes["searchWrapper"]}>
        <TextInput
          placeholder="Search for system by store code or store name."
          onChange={(e) => onSearchChange(e.target.value)}
          autoFocus
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="20"
                  height="20"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={classes["toggleContainer"]}>
        <Switch
          label="Show only online stores"
          onChange={(e) => onOnlineOnlyChange(e.target.checked)}
        />
      </div>
      <div className={classes["refreshContainer"]}>
        <Button
          onClick={onRefresh}
          startIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="20"
              height="20"
            >
              <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
          }
        />
      </div>
    </div>
  );
};

export default SearchHeader;
